import * as React from "react";

import {
    List,
    TopToolbar,
    EditButton,
    CreateButton,
    ExportButton,
    Datagrid,
    TextField,
    SearchInput,
} from "react-admin";


const ListActions = (props) => (
    <TopToolbar>
        <CreateButton />
        <ExportButton />
    </TopToolbar>
);

const AdminFilters = [<SearchInput  source="admin_name" alwaysOn />];

export const AdminList = (props) => (
    <List {...props} filters={AdminFilters} actions={<ListActions />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="admin_name" />
            <EditButton />
        </Datagrid>
    </List>
);